module.exports = ".action {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  cursor: not-allowed; }\n  .action i {\n    margin-right: 10px; }\n  .green {\n  color: #00985c;\n  cursor: pointer; }\n  .red {\n  color: #e64c65;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/contratos/admin-contratos-acoes/admin-contratos-acoes.component.scss
// module id = ./src/app/components/admin/contratos/admin-contratos-acoes/admin-contratos-acoes.component.scss
// module chunks = main